// TODO: if it's integer-y, don't change it?
export const buildKey = (...args) => {
  return args.map((item) => (isFinite(item) ? +item : item));
};
